<template>
  <div class="daiban-container">
    <!-- <van-nav-bar class="home-nav-bar" title=" 该模块火速开发中。。。233" /> -->
    <van-tabbar v-model="active" :fixed="false" @change="onChange">
      <van-tabbar-item :badge="count.khCount == 0?'':count.khCount">客户</van-tabbar-item>
      <van-tabbar-item :badge="count.htCount == 0?'':count.htCount">合同</van-tabbar-item>
      <van-tabbar-item :badge="count.skCount == 0?'':count.skCount">收款</van-tabbar-item>
      <van-tabbar-item :badge="count.dkCount == 0?'':count.dkCount">执行垫款</van-tabbar-item>
    </van-tabbar>
    <van-tabs @click="onClick" v-model="activeTab">
      <van-tab title="未处理"></van-tab>
      <van-tab title="已处理"></van-tab>
    </van-tabs>
    <div>
      <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
        <total-component :totalValue="total" />
        <van-checkbox-group v-model="checkedArr" ref="checkedGroup">
          <van-cell v-for="(item, index) in list" :key="index">
            <van-checkbox :name="item.bussId" shape="square" icon-size="18px" v-if="queryParams.backlogType == 4 && queryParams.checkStatus == 0 && item.backType !== 2">
              <div class="name_wrap">{{item.title}}</div>
            </van-checkbox>
            <div class="name_wrap" v-else>{{item.title}}</div>
            <div class="content" v-html="item.content"></div>
            <div class="bottom">
              <div class="time_info"><van-icon name="user-circle-o" size="20" color="#999"></van-icon><span>{{item.deptName}}</span></div>
            </div>
            <div class="bottom">
              <div class="time_info"><van-icon name="underway-o" size="20" color="#999"></van-icon><span>{{item.startTime}}</span></div>
              <van-tag size="large" v-if="item.checkStatus == 1" type="primary" >已处理</van-tag>
              <van-tag size="large" v-if="item.checkStatus == 3" type="warning" >超时已处理</van-tag>
              <van-button type="info" size="mini" @click="toHandle(item)" v-if="(item.checkStatus == 0 || item.checkStatus == 2) && item.backType != 2" >处理</van-button>
            </div>
            <div v-if="item.backType === 2" style="color: #fd811e;">流程已推送企业微信，请在企业微信中审批</div>
          </van-cell>
        </van-checkbox-group>
      </van-list>
      <empty-component v-if="isEmpty" />
    </div>
    <div class="batch_operation" v-if="queryParams.backlogType == 4 && queryParams.checkStatus == 0" v-hasPermi="['cont:advances:batch']" >
      <van-button type="info" size="mini" @click="batchOperation">批量审批</van-button>
    </div>
    <!-- 批量部门审核 -->
    <van-dialog v-model="verifyFormShow" title="执行垫款批量部门审核" width="95%" style="height:45%" class="verifyClue" :beforeClose="verifyBeforeClose" show-cancel-button>
      <van-form ref="verifyForm" validate-trigger="onSubmit">
        <van-cell title="审核状态：" required>
          <template>
            <van-radio-group v-model="verifyForm.checkStatus" direction="horizontal">
              <van-radio name="2" clickable @click="verifyForm.checkStatus = '2'">通过</van-radio>
              <van-radio name="1" clickable @click="verifyForm.checkStatus = '1'">不通过</van-radio>
            </van-radio-group>
          </template>
        </van-cell>
        <van-field v-if="verifyForm.checkStatus == '4'" readonly clickable v-model="verifyForm.checkReasonTypeName" @click="showPicker('checkReasonType')" label="驳回原因" placeholder="请选择驳回原因" :rules="[{ required: true }]" required />
        <van-field
          v-model="verifyForm.checkReason"
          rows="2"
          autosize
          label="审核意见"
          placeholder="请输入审核意见"
          type="textarea"
          show-word-limit
          :rules="verifyForm.checkStatus == '1'?[{ required: true }]:[]" :required="verifyForm.checkStatus == '1'?true:false"
        />
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import { Tabbar, TabbarItem, Toast, Checkbox, CheckboxGroup } from 'vant'
import { listBacklog, getCountItem } from '@/api/admi/user'
import payment from '@/api/cont/payment'
import { mapGetters } from 'vuex'
import TotalComponent from '@/components/common/Total'
import EmptyComponent from '@/components/common/Empty'
import store from '@/store'
export default {
  name: 'DaibanIndex',
  components: {
    [Toast.name]: Toast,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    TotalComponent,
    EmptyComponent
  },
  computed: {
    ...mapGetters({
      userinfo: 'userinfo'
    })
  },
  props: {},
  data() {
    return {
      active: 0,
      activeTab: 0,
      count: {
        khCount: '',
        htCount: '',
        skCount: '',
        dkCount: ''
      },
      loading: false,
      finished: false,
      list: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        backlogType: 1,
        checkStatus: 0,
        userId: null,
        childType: null,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      isEmpty: false,
      checkedArr: [],
      verifyFormShow: false,
      verifyForm: {
        contAdvancesId: '',
        checkStatus: '2',
        checkReason: ''
      }

    }
  },
  watch: {},
  async created() {
    await store.dispatch('user/GetInfo')
    await store.dispatch('user/GetDbCount')
    if (this.userinfo.userId && this.userinfo.roles.length > 0) {
      if (this.$route.query.type) {
        this.active = Number(this.$route.query.type)
        this.queryParams.backlogType = Number(this.$route.query.type) + 1
      }
      this.queryParams.userId = this.userinfo.userId
      await this.getList()
      await this.getCountItem()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = '待办'
    },
    onChange(index) {
      this.list = []
      this.queryParams.backlogType = this.active + 1
      if (this.active == 2 || this.active == 3) {
        if (this.userinfo.roles.length > 0) {
          if (this.userinfo.roles.some(res => { return res.roleKey === 'CONT_CWQR' })) {
            if (this.active == 3) {
              this.queryParams.childType = 6
            } else {
              this.queryParams.childType = null
            }
            this.queryParams.userId = null
          } else {
            this.queryParams.userId = this.userinfo.userId
          }
        }
      } else {
        this.queryParams.userId = this.userinfo.userId
        this.queryParams.childType = null
      }
      this.queryParams.pageNum = 1
      this.getList()
    },
    onClick(name, title) {
      this.list = []
      this.queryParams.checkStatus = this.activeTab
      this.queryParams.pageNum = 1
      this.getList()
    },
    async getList() {
      this.loading = true
      const res = await listBacklog(this.queryParams)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        this.queryParams.pageNum += 1
        this.total = res.total
        this.finished = this.list.length >= res.total
        this.loading = false
      }
    },
    async getCountItem() {
      if (this.userinfo.roles.length > 0) {
        if (this.userinfo.roles.some(res => { return res.roleKey === 'CONT_CWQR' })) {
        // const number = ''
          const res = await getCountItem({ ...this.queryParams, backlogType: 3, userId: null })
          if (res.code == 200) {
          // number = res.data
            this.count.skCount = res.data.skCount
          }
          const res2 = await getCountItem({ ...this.queryParams, backlogType: 4, childType: 6, userId: null })
          if (res2.code == 200) {
          // number.khCount += res2.data.khCount
          // number.htCount += res2.data.htCount
          // number.skCount += res2.data.skCount
          // number.dkCount += res2.data.dkCount
          // this.count = number
            this.count.dkCount = res.data.dkCount
          }
        } else {
          const res = await getCountItem({ ...this.queryParams, backlogType: null })
          if (res.code == 200) {
            this.count = res.data
          }
        }
      }
    },
    onLoad() {
      this.getList()
    },
    toHandle(item) {
      if (this.active == 0) {
        this.$router.push({
          path: '/daiban/custApproval',
          query: { id: item.bussId, type: item.childType, [item.childType == 1 ? 'customerShareId' : 'highSeasApplyId']: item.remark }
        })
      } else if (this.active == 1) {
        this.$router.push({
          path: '/cont/approve/detail',
          query: { id: item.bussId }
        })
      } else if (this.active == 2) {
        this.$router.push({
          path: '/cont/payment/detail',
          query: { id: item.bussId, active: 1 }
        })
      } else if (this.active == 3) {
        this.$router.push({
          path: '/cont/advances/detail',
          query: { id: item.bussId, type: item.childType }
        })
      }
    },
    batchOperation() {
      console.log(this.checkedArr)
      if (this.checkedArr.length == 0) {
        Toast.fail('请先勾选需要批量操作的数据')
        return
      }
      this.verifyFormShow = true
    },
    async verifyBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.verifyForm.validate()
          this.checkedArr.forEach(item => {
            this.verifyForm.contAdvancesId = item
            payment.updateAdvances(this.verifyForm)
              .then((res) => {
                if (res.code == 200) {
                  if (item == this.checkedArr[this.checkedArr.length - 1]) {
                    Toast.success('批量审核成功')
                    this.checkedArr = []
                    setTimeout(() => {
                      this.onClick()
                      this.getCountItem()
                      store.dispatch('user/GetDbCount')
                    }, 600)
                  }
                } else {
                  Toast.fail(res.msg)
                }
              }).catch(() => {})
            done()
          })
          // this.verifyForm.contAdvancesId = this.checkedArr
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.bmshVisible = false
      }
    }
  }
}
</script>

<style scoped lang='less'>
@import url("@/style/index.less");
.daiban-container{
  /deep/ .van-tabbar{
    height: 100px;
    background-color: #3a75c5;
    .van-tabbar-item--active{
      background-color: #3a75c5;
      .van-tabbar-item__text{
        background-color: #fff;
        color: #3a75c5;
      }
    }
    .van-tabbar-item__text{
      font-size: 30px;
      color: #fff;
      padding: 10px 20px;
      border-radius: 10px;
    }
    .van-tabbar-item{
      .van-tabbar-item__icon{
        .van-info{
          right: -40px;
          // background-color: #4169E1;
          background-color: #fff;
          color: #3a75c5;
        }
      }
    }
  }
  /deep/.van-tabs{
    margin-top: 10px;
    .van-tabs__line{
      background-color: #191970;
    }
  }
  /deep/.van-list{
    padding-top: 0;
    padding-bottom: 220px;
    .name_wrap{
      font-size: 30px;
      color: #0000CD;
    }
    .content{
      font-size: 28px;
      color: #666;
    }
    .bottom{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .time_info{
        display: flex;
        align-items: center;
        span{
          margin-left: 10px;
          color: #999;
        }
      }
      .van-button{
        padding: 10px 40px;
      }
    }
  }
}
.batch_operation{
  position: fixed;
  bottom: calc(120px + env(safe-area-inset-bottom));
  width: 100%;
  background-color: #fff;
  padding: 12px 0px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .van-button{
    margin-right: 30px;
    padding: 0px 30px;
  }
}
.verifyClue /deep/.van-dialog__content {
  height: 64%;
}
.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
</style>
